module.exports = __webpack_public_path__ + "Lato-Light.5b761f2d1e4259ea6ac7";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-Light.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Light.ttf
// module chunks = styles